module.exports = __webpack_public_path__ + "img/h5_game_detail_cannon20_regular.b5b62dc0.jpg";